import { useCaptainNetwork } from "../../hooks/useCaptainNetwork";
import { NetworkMode } from "../../lib/captainMesh/networkState";

/**
 * The captain's ONE network surface (§15). Vocabulary is deliberately small and
 * behavioural — "Connected" / "Saving locally" tells the captain what happens to
 * the order they punch next; peer counts and reconciliation phases are mesh
 * internals a waiter should never have to parse. The e2e suite matches on
 * "Connected" and "Local mode" — keep both strings.
 */
export function NetworkIndicator({ plain = false } = {}) {
  const { mode, isLocalOnly, isReconciling } = useCaptainNetwork();

  let color = "bg-success";
  let text = "Connected";

  if (isReconciling) {
    color = "bg-warning";
    text = "Syncing…";
  } else if (mode === NetworkMode.SERVER_DEGRADED) {
    color = "bg-warning";
    text = "Slow connection";
  } else if (mode === NetworkMode.MESH_ACTIVE) {
    color = "bg-info";
    text = "Local mode";
  } else if (mode === NetworkMode.MESH_DEGRADED || mode === NetworkMode.MESH_CONNECTING) {
    color = "bg-warning";
    text = "Local mode";
  } else if (isLocalOnly || mode === NetworkMode.SERVER_OFFLINE) {
    color = "bg-danger";
    text = "Local mode";
  }

  // The label stays at every width: on a phone the old `hidden sm:inline`
  // degraded this to a bare 8px dot with no text alternative at all.
  return (
    <div
      // `plain` sits on a white desktop header (DESIGN.md §4); the default sits on
      // the captain phone's primary-coloured bar (captainpad-language.md).
      className={plain
        ? "flex items-center gap-1.5 text-meta font-medium text-muted-foreground shrink-0"
        : "flex items-center gap-2 px-2 py-1 bg-primary-foreground/10 rounded-full text-micro font-bold text-primary-foreground/90 shrink-0"}
      title={text}
    >
      <span className={`w-2 h-2 rounded-full ${color} ${isReconciling ? "animate-pulse" : ""}`}></span>
      <span>{text}</span>
    </div>
  );
}
